import { join } from 'juriquery'

export const EXPORTS_ROUTE = `/exports`
export const PAYMENT_REQUIRED_ROUTE = `/payment-required`
export const PAYMENT_REQUIRED_ERROR_ROUTE = `/payment-required/:error?`
export const PERMISSION_REQUIRED_ROUTE = `/permission-required`

export const NOT_FOUND_ROUTE = `/404`
export const DEVICE_ONLY_ROUTE = `/device-only`
export const USER_DEACTIVATED_ROUTE = `/user-deactivated`
export const NO_ACCESS_ROUTE = `/no-access`
export const UNAUTHORIZED_ROUTE = `/unauthorized`
export const MOBILE_APP_ROUTE = `/mobile/app`
export const CLINICS_ROUTE = `/clinics`
export const CLINIC_ROUTE = `/clinics/:clinicId`

export const getExportsRoute = () => EXPORTS_ROUTE

export const getPaymentRequiredRoute = (
  errorType?: string,
  moduleId?: string,
) =>
  join(
    `${PAYMENT_REQUIRED_ERROR_ROUTE.replace(
      '/:error?',
      errorType ? `/${errorType}` : '',
    )}`,
    {
      moduleId,
    },
  )

export const getPermissionRequiredRoute = () => PERMISSION_REQUIRED_ROUTE

export const getNotFoundRoute = () => NOT_FOUND_ROUTE

export const getDeviceOnlyRoute = () => DEVICE_ONLY_ROUTE

export const getUserDeactivatedRoute = () => USER_DEACTIVATED_ROUTE

export const getNoAccessRoute = () => NO_ACCESS_ROUTE

export const getNoAccessModuleRoute = (moduleId: string) =>
  `${getNoAccessRoute()}/${moduleId}}`

export const getUnauthorizedRoute = (props: { external?: boolean } = {}) =>
  join(UNAUTHORIZED_ROUTE, props)
